module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section04_01_american-village-cf04e5dc0de33f6bc20e2e348bf06d35.jpg";